import type * as React from "react"

const PROJECT_ENTITY_CATEGORIES = {
  STANDARD: 1,
  CHANGE_REQUEST: 2,
  OTHER: 3
} as const

type ProjectTypeCategoryKeys = keyof typeof PROJECT_ENTITY_CATEGORIES
type ProjectEntityCategories =
  (typeof PROJECT_ENTITY_CATEGORIES)[ProjectTypeCategoryKeys]

const PROJECT_ENTITY_CATEGORIES_MAP: Record<
  ProjectEntityCategories,
  {
    id: ProjectEntityCategories
    value: ProjectEntityCategories
    label: string
    style: React.CSSProperties
  }
> = {
  [PROJECT_ENTITY_CATEGORIES.STANDARD]: {
    id: PROJECT_ENTITY_CATEGORIES.STANDARD,
    value: PROJECT_ENTITY_CATEGORIES.STANDARD,
    label: "Standard",
    style: {
      color: "#1976D2",
      backgroundColor: "#E3F2FD",
      borderColor: "#E3F2FD"
    }
  },
  [PROJECT_ENTITY_CATEGORIES.CHANGE_REQUEST]: {
    id: PROJECT_ENTITY_CATEGORIES.CHANGE_REQUEST,
    value: PROJECT_ENTITY_CATEGORIES.CHANGE_REQUEST,
    label: "Change Request",
    style: {
      color: "#FF9800",
      backgroundColor: "#FFF3E0",
      borderColor: "#FFF3E0"
    }
  },
  [PROJECT_ENTITY_CATEGORIES.OTHER]: {
    id: PROJECT_ENTITY_CATEGORIES.OTHER,
    value: PROJECT_ENTITY_CATEGORIES.OTHER,
    label: "Other",
    style: {
      color: "#616d73",
      backgroundColor: "#ECEFF1",
      borderColor: "#ECEFF1"
    }
  }
}

export {
  PROJECT_ENTITY_CATEGORIES,
  PROJECT_ENTITY_CATEGORIES_MAP,
  type ProjectEntityCategories
}
